import styled from"@emotion/styled";export const AssessmentContainer=styled.div`
  white-space: pre-wrap;
`;export const ButtonTextContainer=styled.div`
  font-size: 16px;
`;